import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import './headerV3.component.css'


const HeaderV3 = () =>{
    const headerRef = useRef(null);
    const location = useLocation();
    const [appsOpen, setAppsOpen] = useState(false);
    const appsDropdownRef = useRef(null);
    const [solutionsOpen, setSolutionsOpen] = useState(false);
    const solutionsDropdownRef = useRef(null);

    useEffect(() => {
      // On route change: close any open offcanvas and restore body scroll
      const offcanvasEl = document.getElementById('navbarNav');
      if (offcanvasEl && window.bootstrap) {
        const existing = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (existing) {
          existing.hide();
        }
      }

      // Clean up any leftover Bootstrap body locks from previous navigation
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) backdrop.remove();

      setAppsOpen(false);
      setSolutionsOpen(false);
    }, [location.pathname]);

    useEffect(() => {
      // Initialize Bootstrap Offcanvas on mount
      const offcanvasEl = document.getElementById('navbarNav');
      let offcanvasInstance;
      if (offcanvasEl && window.bootstrap) {
        offcanvasInstance = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
      }

      return () => {
        if (offcanvasInstance) {
          try { offcanvasInstance.dispose(); } catch (_) {}
        }
      };
    }, []);

    useEffect(() => {
      if (!appsOpen) return;
      const handler = (e) => {
        if (appsDropdownRef.current && !appsDropdownRef.current.contains(e.target)) {
          setAppsOpen(false);
        }
      };
      document.addEventListener('mousedown', handler);
      return () => document.removeEventListener('mousedown', handler);
    }, [appsOpen]);

    useEffect(() => {
      if (!solutionsOpen) return;
      const handler = (e) => {
        if (solutionsDropdownRef.current && !solutionsDropdownRef.current.contains(e.target)) {
          setSolutionsOpen(false);
        }
      };
      document.addEventListener('mousedown', handler);
      return () => document.removeEventListener('mousedown', handler);
    }, [solutionsOpen]);

    return(
        <>
         <header ref={headerRef} className="header navbar navbar-expand-lg navbar-dark position-absolute navbar-sticky navbar-stuck">
          <div className="container  px-3 pt-2 ">
          <NavLink to="/" className="navbar-brand pe-3">
            <img src={`${process.env.PUBLIC_URL}/assets/img/logo_large 1.png`} width="150" alt="orbix" />

          </NavLink>
            <button type="button" className="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
            </button>
            <div id="navbarNav" className="offcanvas offcanvas-end bg-dark">
              <div className="offcanvas-header border-bottom border-light">
                <h5 className="offcanvas-title text-white">Menu</h5>
                <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>
              <div className="offcanvas-body  justify-content-center">
                <ul className="navbar-nav mb-2 mb-lg-0 no-desktop" style={{ flexDirection: 'column' }}>
                  <li className="nav-item mb-1">
                    <span className="nav-link text-white" style={{ fontWeight: 600, opacity: 0.5, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', paddingBottom: '6px' }}>
                      &nbsp;Apps &amp; Features
                    </span>
                    <NavLink to="/apps/prime" className="nav-link d-lg-inline-flex text-white" activeclassname="active" style={{ paddingLeft: '1.5rem', paddingTop: '4px', paddingBottom: '4px' }}>
                      &nbsp;AI Oversight
                    </NavLink>
                    <NavLink to="/apps/oculo" className="nav-link d-lg-inline-flex text-white" activeclassname="active" style={{ paddingLeft: '1.5rem', paddingTop: '4px', paddingBottom: '4px' }}>
                      &nbsp;Oculo — AI Document Extraction
                    </NavLink>
                    <NavLink to="/features" className="nav-link d-lg-inline-flex text-white" activeclassname="active" style={{ paddingLeft: '1.5rem', paddingTop: '4px', paddingBottom: '4px' }}>
                      &nbsp;Digital NDT Workflow
                    </NavLink>
                  </li>
                  <li className="nav-item mb-1">
                    <span className="nav-link text-white" style={{ fontWeight: 600, opacity: 0.5, fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', paddingBottom: '6px' }}>
                      &nbsp;Solutions
                    </span>
                    <NavLink to="/solutions/ai-quality-program" className="nav-link d-lg-inline-flex text-white" activeclassname="active" style={{ paddingLeft: '1.5rem', paddingTop: '4px', paddingBottom: '4px' }}>
                      &nbsp;AI Quality Program
                    </NavLink>
                    <NavLink to="/solutions" className="nav-link d-lg-inline-flex text-white" activeclassname="active" style={{ paddingLeft: '1.5rem', paddingTop: '4px', paddingBottom: '4px' }}>
                      &nbsp;On-Demand Expertise
                    </NavLink>
                  </li>
                  <li className="nav-item mb-3">
                    <NavLink to="/news" className="nav-link d-lg-inline-flex text-white" activeclassname="active">
                      &nbsp;News
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>

                {/* Apps & Features dropdown — React-controlled, click only */}
                <div className="apps-dropdown-wrapper d-none d-lg-flex me-3" ref={appsDropdownRef}>
                  <button
                    className="nav-link text-white apps-dropdown-toggle"
                    onClick={() => setAppsOpen(v => !v)}
                    aria-expanded={appsOpen}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0.5rem 0' }}
                  >
                    &nbsp;Apps &amp; Features <span className="apps-dropdown-caret" style={{ fontSize: '10px', marginLeft: '4px', opacity: 0.7 }}>▼</span>
                  </button>
                  {appsOpen && (
                    <ul className="apps-dropdown-menu" style={{ background: '#1C1438', border: '1px solid rgba(129,107,255,0.3)', borderRadius: '12px', padding: '8px', minWidth: '240px', listStyle: 'none', margin: 0 }}>
                      <li>
                        <NavLink to="/apps/prime" className="apps-dropdown-item" onClick={() => setAppsOpen(false)}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,107,255,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ fontWeight: 700, display: 'block', fontSize: '14px' }}>AI Oversight</span>
                          <span style={{ display: 'block', fontSize: '11.5px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>AI Quality Team for NDT Projects</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/apps/oculo" className="apps-dropdown-item" onClick={() => setAppsOpen(false)}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,107,255,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ fontWeight: 700, display: 'block', fontSize: '14px' }}>Oculo</span>
                          <span style={{ display: 'block', fontSize: '11.5px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>AI Document Extraction</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/features" className="apps-dropdown-item" onClick={() => setAppsOpen(false)}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,107,255,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ fontWeight: 700, display: 'block', fontSize: '14px' }}>Digital NDT Workflow</span>
                          <span style={{ display: 'block', fontSize: '11.5px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>End-to-end inspection pipeline</span>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </div>

                {/* Solutions dropdown — React-controlled, click only */}
                <div className="apps-dropdown-wrapper d-none d-lg-flex me-3" ref={solutionsDropdownRef}>
                  <button
                    className="nav-link text-white apps-dropdown-toggle"
                    onClick={() => setSolutionsOpen(v => !v)}
                    aria-expanded={solutionsOpen}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0.5rem 0' }}
                  >
                    &nbsp;Solutions <span className="apps-dropdown-caret" style={{ fontSize: '10px', marginLeft: '4px', opacity: 0.7 }}>▼</span>
                  </button>
                  {solutionsOpen && (
                    <ul className="apps-dropdown-menu" style={{ background: '#1C1438', border: '1px solid rgba(129,107,255,0.3)', borderRadius: '12px', padding: '8px', minWidth: '240px', listStyle: 'none', margin: 0 }}>
                      <li>
                        <NavLink to="/solutions/ai-quality-program" className="apps-dropdown-item" onClick={() => setSolutionsOpen(false)}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,107,255,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ fontWeight: 700, display: 'block', fontSize: '14px' }}>AI Quality Program</span>
                          <span style={{ display: 'block', fontSize: '11.5px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>Continuous AI-driven oversight</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/solutions" className="apps-dropdown-item" onClick={() => setSolutionsOpen(false)}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,107,255,0.15)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <span style={{ fontWeight: 700, display: 'block', fontSize: '14px' }}>On-Demand Expertise</span>
                          <span style={{ display: 'block', fontSize: '11.5px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>Expertise delivered anywhere</span>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </div>
                <NavLink to="/news"  className="nav-link d-none d-lg-inline-flex me-3 text-white " activeclassname="active">
                  &nbsp;News
                </NavLink>

                {/* <a href="https://demo.orbixnde.com" target="__blank" className="btn btn-primary btn-sm fs-sm rounded d-none d-lg-inline-flex">
                  &nbsp;Sign In
                </a> */}

                {/* American Flag - Figma: 38x38 */}
                <div className="navbar-flag d-none d-lg-flex ms-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/united-states-flag.png`}
                    alt="US"
                    width="38"
                    height="38"
                    className="flag-icon"
                  />
                </div>

          </div>
      </header>

        </>
    )
}

export default HeaderV3;
